import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.scss'],
})
export class ModalBasicComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalBasicComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string
      content: string
      button: string
      iconWarning: boolean
      showClose: boolean
    }
  ) {}

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close();
  }
}
